import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BUSINESS, LOGO_URL } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="relative bg-surface border-t border-white/10" data-testid="site-footer">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Delta Grassmasters LLC logo" className="h-14 w-auto object-contain" />
              <div>
                <p className="font-display font-extrabold uppercase tracking-tight text-[#f2f4f0]">
                  Delta Grassmasters LLC
                </p>
                <p className="text-xs uppercase tracking-[0.25em] text-brand">
                  {BUSINESS.tagline}
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm text-[#8d948f] leading-relaxed">
              Commercial landscape construction & maintenance. Licensed, bonded
              and insured in Arkansas and Mississippi.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-[#8d948f] mb-4">Navigate</p>
            <ul className="space-y-3">
              {[
                { l: "Home", h: "#home" },
                { l: "Services", h: "#services" },
                { l: "About", h: "#about" },
                { l: "Contact", h: "#contact" },
              ].map((i) => (
                <li key={i.h}>
                  <a href={i.h} className="text-sm text-[#c7ccc4] hover:text-brand transition-colors">
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#8d948f] mb-4">Contact</p>
            <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-sm text-[#c7ccc4] hover:text-brand transition-colors mb-3">
              <Phone className="h-4 w-4 text-brand" /> {BUSINESS.phone}
            </a>
            <a href={BUSINESS.mapLink} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-sm text-[#c7ccc4] hover:text-brand transition-colors">
              <MapPin className="h-4 w-4 text-brand mt-0.5 shrink-0" /> {BUSINESS.address}
            </a>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-1.5 bg-brand px-5 py-3 text-sm font-bold text-[#0b120a] hover:bg-brand-hover transition-colors group"
            >
              Request a Quote
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#5c625b]">
          <p>© {new Date().getFullYear()} Delta Grassmasters LLC. All rights reserved.</p>
          <p>{BUSINESS.hours}</p>
        </div>
      </div>
    </footer>
  );
};
